import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { PREF_OPTIONS } from '@/assets/lib/hope-options'
import departmentOptions from '@/utils/format-edit/departmentOptions.json'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoRequestsCard',
  props: {
    currentCardId: null,
    previewErrors: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
};



const formatData = useNewRirekishoFormatData()
const exampleVisible = ref(false)
const prefOptions = PREF_OPTIONS
const getMode = computed(() => process.env.VUE_APP_MODE)

const requestExamples = computed(() => props.exampleSentences?.request || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  formatData.request +=
    item.description
      .replace(/<br>/gi, '\n')
      .replace('OOO', String(formatData.nowNensyu || ''))
      .replace('XXX', String(formatData.kibouNensyu || '')) + '\n'
}

return { __sfc: true,props, formatData, exampleVisible, prefOptions, getMode, requestExamples, onSelectExample, NewRirekishoExampleSentenceDialog, departmentOptions, hopeIndustryOptions, hopeJobcategoryOptions }
}

})